module.exports = "https://www.gc-pro.gnp.com.mx/4776f59a8620aeedf9dfe8dd4501451a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/calendar.svg
// module id = 1802
// module chunks = 0